import script from "./panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./panel.vue?vue&type=script&lang=ts&setup=true"

import "./panel.vue?vue&type=style&index=0&id=1c09a5b8&lang=scss&scoped=true"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c09a5b8"]])

export default __exports__